export default __webpack_public_path__ + "static/media/trello1.37e5beb4.png";